<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Call Attempts</span>
        </template>

        <div class="call-attempts-body">
            <el-button
                type="primary"
                :loading="loading"
                :disabled="loading"
                @click="logCall"
            >
                {{ buttonLabel }}
            </el-button>

            <p class="call-meta" v-if="enquiry.call_attempts > 0">
                Calls logged: {{ enquiry.call_attempts }}
                <span v-if="enquiry.last_call_at"> · Last: {{ formatTimestamp(enquiry.last_call_at) }}</span>
            </p>
            <p class="call-meta muted" v-else>
                No calls logged yet
            </p>
        </div>
    </el-card>
</template>

<script>
import {
    ElCard, ElButton
} from 'element-plus'

const ORDINAL_WORDS = [
    'First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Ninth', 'Tenth',
    'Eleventh', 'Twelfth', 'Thirteenth', 'Fourteenth', 'Fifteenth', 'Sixteenth', 'Seventeenth', 'Eighteenth', 'Nineteenth', 'Twentieth'
];

function getOrdinalLabel(n) {
    if (n >= 1 && n <= ORDINAL_WORDS.length) {
        return ORDINAL_WORDS[n - 1];
    }

    const mod100 = n % 100;
    if (mod100 >= 11 && mod100 <= 13) {
        return n + 'th';
    }

    switch (n % 10) {
        case 1: return n + 'st';
        case 2: return n + 'nd';
        case 3: return n + 'rd';
        default: return n + 'th';
    }
}

export default {
    name: "EnquiryCallAttempts",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: { ElCard, ElButton },
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        callAttempts() {
            return parseInt(this.enquiry?.call_attempts || 0, 10);
        },
        buttonLabel() {
            return getOrdinalLabel(this.callAttempts + 1) + ' Call Button';
        }
    },
    methods: {
        formatTimestamp(value) {
            if (!value) {
                return '';
            }
            return value;
        },
        logCall() {
            if (this.loading) {
                return;
            }

            let currentObj = this;
            currentObj.loading = true;
            axios.post('/enquiry/logcall?id=' + this.enquiry.id).then(function (response) {
                toastr.success(response.data.message || 'Call logged successfully.');
                currentObj.$emit('saved');
                currentObj.loading = false;
            }).catch(function (error) {
                currentObj.loading = false;
                const message = error?.response?.data?.message || 'Something Wrong try again.';
                toastr.error(message);
            });
        }
    }
}
</script>

<style scoped>
.call-attempts-body {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.call-meta {
    margin: 0;
    font-size: 13px;
}
.call-meta.muted {
    color: #909399;
}
</style>
